export { DSGlobalHeader, DSGlobalHeaderWithSchema } from './MobileGlobalHeader.js';
